export const copyToClipboard = async (text: string) => {
  if (!navigator.clipboard || !window.isSecureContext) {
    return fallbackCopyText(text);
  }

  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    return fallbackCopyText(text);
  }
};

export const fallbackCopyText = async (text: string) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.left = "-999999px";
  textArea.style.top = "-999999px";
  document.body.appendChild(textArea);

  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand("copy");
    document.body.removeChild(textArea);

    if (successful) {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    document.body.removeChild(textArea);
    return false;
  }
};
